var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgPlayVideo = function SvgPlayVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.781 6.887v9.793l9.172-4.899zm0 0",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 .02C5.371.02 0 5.383 0 12s5.371 11.98 12 11.98S24 18.617 24 12 18.629.02 12 .02zM8.648 6.887l9.168 4.894-9.168 4.899zm0 0",
    fill: "#db2b42"
  })));
};
export default SvgPlayVideo;